import React, { useState } from 'react';
import { DVIPointRow, DVIPointRowNoteFields } from './DVIPointRow';
import { DVIInspectionItem, DVIItemStatus } from '../../types/dvi';
import { DviNotePresetGroup } from '../../services/api/dviNotePresetsApi';

export interface DVICategorySectionProps {
  categoryName: string;
  items: DVIInspectionItem[];
  onItemStatusChange: (itemId: number,
    status: Exclude<DVIItemStatus, 'pending'>, notes?: string | null) => void;
  onConvert: (item: DVIInspectionItem) => void;
  onReadingChange?: (itemId: number, reading_value: string) => void;
  /** WP-07 — save note/measurement without requiring a status. */
  onNoteChange?: (itemId: number, fields: DVIPointRowNoteFields) => void;
  /** WP-07 — shop preset groups, fetched once by the form. */
  presetGroups?: DviNotePresetGroup[];
}

export const DVICategorySection: React.FC<DVICategorySectionProps> = ({
  categoryName, items, onItemStatusChange, onConvert, onReadingChange, onNoteChange, presetGroups,
}) => {
  const [expanded, setExpanded] = useState(true);
  const statusItems = items.filter(i => (i.point_type ?? 'status') === 'status');
  const done = statusItems.filter(i => i.status !== 'pending').length;
  const total = statusItems.length;

  return (
    <div style={{ borderBottom: '1px solid #ddd', marginBottom: 8 }}>
      <div
        role="button"
        onClick={() => setExpanded(e => !e)}
        style={{
          background: '#f5f5f5', padding: '10px 12px',
          fontWeight: 700, textTransform: 'uppercase', fontSize: 13,
          letterSpacing: 0.5,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          cursor: 'pointer', minHeight: 44,
        }}
      >
        <span>{expanded ? '▾ ' : '▸ '}<span>{categoryName}</span></span>
        <span style={{
          background: done === total && total > 0 ? '#22c55e' : '#888',
          color: 'white', padding: '2px 8px', borderRadius: 12, fontSize: 12,
        }}>
          {done}/{total}
        </span>
      </div>
      {expanded && items.map(it => (
        <DVIPointRow
          key={it.id}
          item={it}
          onStatusChange={(status, notes) => onItemStatusChange(it.id, status, notes)}
          onConvert={onConvert}
          onReadingChange={onReadingChange}
          onNoteChange={onNoteChange}
          presetGroups={presetGroups}
        />
      ))}
    </div>
  );
};

export default DVICategorySection;
